import ReactGA from 'react-ga';

ReactGA.initialize('UA-124741864-2');

export default ReactGA;



// WEBPACK FOOTER //
// ./src/analytics/index.js